import Type from "@/model/types/Type";

const type = {
    INPUT: "I",
    TEXTAREA: "T",
    RADIO: "R",
    SELECT: "S",
    SELECT_COLOR: "SC",
    CHECKBOX: "C",
    LABEL: "L",
}

const list = [
    {value: "I", text: "Comum"},
    {value: "T", text: "Texto grande"},
    {value: "S", text: "Lista de Texto"},
    {value: "SC", text: "Lista de Cores"},
    {value: "R", text: "Escolha única"},
    {value: "L", text: "Título"},
    /*{value: "C", text: "Escolha múltipla"},NÃO IMPLEMENTADO*/
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const isList = function (typeInput) {
    return typeInput === type.RADIO || typeInput === type.SELECT || typeInput === type.SELECT_COLOR || typeInput === type.CHECKBOX
}

export default {
    type,
    list,
    contains,
    isList
}